import { useCallback, useEffect } from 'react';

type KeyboardCallback = (event: KeyboardEvent) => void;

// This hook listens for a keyup event and calls the provided function when the keyup event matches the provided keyCode
// Tried useKeypress and useKey from react-use, but they didn't work as expected
export const useKeyup = (keyCode: string, fn: KeyboardCallback) => {
  const handleKeyup = useCallback(
    (event: KeyboardEvent) => {
      if (event.code === keyCode) {
        fn(event);
      }
    },
    [fn, keyCode],
  );
  useEffect(() => {
    document.addEventListener('keyup', handleKeyup);
    return () => document.removeEventListener('keyup', handleKeyup);
  }, [fn, keyCode, handleKeyup]);
};
